import React from 'react';

import { Box, Typography } from '@mui/material';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import PeopleIcon from '@mui/icons-material/People';
import FlagIcon from '@mui/icons-material/Flag';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import PublicIcon from '@mui/icons-material/Public';
import ListAltIcon from '@mui/icons-material/ListAlt';

import RouteWrapper from './RouteWrapper';

import StyledGridItemWithHeader from '../components/shared/StyledGridItemWithHeader';

const DgvClub = ()=> {
    return (
        <RouteWrapper>
            <StyledGridItemWithHeader header="DGV Club Members Only" gridItemProps={{ xs: 12 }}>
                <Box sx={{ width: '100%' }}>
                  <Typography component="p" variant="body2" sx={{ m: 1 }}>
                    Interested in seeing more advanced metrics? By joining the DGV Club you will gain access to even more data including:
                  </Typography>

                  <List>
                      <ListItem>
                          <ListItemIcon>
                              <PeopleIcon />
                          </ListItemIcon>

                          <ListItemText
                              primary="Find out who your biggest rivals are"
                              secondary="You will be able to see your overall record against every player you have played this season."
                          />
                      </ListItem>

                      <ListItem>
                          <ListItemIcon>
                              <ListAltIcon />
                          </ListItemIcon>

                          <ListItemText
                              primary="View your previous cards"
                              secondary="You will be able to click on any of your previous matches and see how you shot on each card."
                          />
                      </ListItem>

                      <ListItem>
                          <ListItemIcon>
                              <FlagIcon />
                          </ListItemIcon>

                          <ListItemText
                              primary="Find out if you need to practice"
                              secondary="You will see which holes you are the master at and which holes you need to load up in practice mode."
                          />
                      </ListItem>

                      <ListItem>
                          <ListItemIcon>
                              <EmojiEventsIcon />
                          </ListItemIcon>

                          <ListItemText
                              primary="Find out how often you ace"
                              secondary="You will get a full list of the holes you've aced this season and how often you do it."
                          />
                      </ListItem>

                      <ListItem>
                          <ListItemIcon>
                              <PublicIcon />
                          </ListItemIcon>

                          <ListItemText
                              primary="Find out how you play each course"
                              secondary="You'll have new insight on where you might need to open Challenge the Valley or Challenge the World mode."
                          />
                      </ListItem>
                  </List>

                  <Typography component="p" variant="body2" sx={{ m: 1 }}>
                      Subscribe today in the Pro Shop to gain access to all of these features!
                  </Typography>
                </Box>
            </StyledGridItemWithHeader>
        </RouteWrapper>
    );
};

export default DgvClub;
